
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-selected-facets .facets{
    display:flex;
    flex-wrap:wrap;
    gap:var(--spacing-4);
    list-style:none;
    padding:0;
    align-items:center;
  }
  .se-selected-facets .bullet{
    display:flex;
    color:var(--brand-neutral-white);
    background-color:var(--brand-primary-2);
    padding-left:var(--spacing-4);
    align-items:center;
    justify-content:space-between;
  }
  .se-selected-facets .bullet .bullet-remove{
      display:flex;
      justify-content:center;
      align-items:center;
      height:44px;
      width:44px;
    }
  .se-selected-facets .bullet .bullet-remove:hover{
        cursor:pointer;
      }
  .se-selected-facets .clear-btn{
    width:100%;
    padding-top:var(--spacing-2);
  }
  @media (min-width: 768px){
  .se-selected-facets .clear-btn{
      width:auto;
      padding-top:0
  }
    }
  .se-selected-facets .clear-btn a{
      color:var(--brand-neutral-gray-600);
      font-size:var(--fs-sm);
      font-weight:var(--fw-bold);
      text-decoration:none;
    }
  .se-selected-facets .clear-btn a:hover{
        cursor:pointer;
        text-decoration:underline;
      }
`;